import { ServiceDetailPrintModel } from "./service-detail-print-model";

export class ServicePrintModel {
  id: number = 0;
  serviceId: number = 0;
  enterpriseLogo: string | null = null;
  enterpriseNit: string = "";
  enterpriseName: string = "";
  branchName: string = "";
  consecutive: number = 0;
  serviceState: string = "";
  branchAddress: string = "";
  branchPhone: string = "";
  dateService: Date = new Date();
  costCenter: string = "";
  constructionSiteAddress: string = "";
  constructionSitePhone: string = "";
  constructionSiteClient: string = "";
  observation: string = "";
  userAuthenticated: string = "";
  serviceDetails: ServiceDetailPrintModel[] = [];
}